/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S4_Li1Inputs */

const en_guide_what_is_json_s4_li1 = /** @type {(inputs: Guide_What_Is_Json_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>API Communication</strong>: REST APIs almost universally use JSON for request and response bodies`)
};

const ko_guide_what_is_json_s4_li1 = /** @type {(inputs: Guide_What_Is_Json_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>API 통신</strong>: REST API는 거의 보편적으로 요청 및 응답 본문에 JSON을 사용합니다`)
};

const ja_guide_what_is_json_s4_li1 = /** @type {(inputs: Guide_What_Is_Json_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>API通信</strong>: REST APIはリクエストとレスポンスのボディにほぼ普遍的にJSONを使用します`)
};

/**
* | output |
* | --- |
* | "<strong>API Communication</strong>: REST APIs almost universally use JSON for request and response bodies" |
*
* @param {Guide_What_Is_Json_S4_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s4_li1 = /** @type {((inputs?: Guide_What_Is_Json_S4_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S4_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s4_li1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s4_li1(inputs)
	return ja_guide_what_is_json_s4_li1(inputs)
});